import { graphql } from 'gatsby';
import React from 'react';
import Card from '@agria/theme/src/components/card/Card';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

const StyledDiv = styled.div`
  ${({ theme: { space, media } }) => css`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: ${space.large};

    @media (min-width: ${media.medium}) {
      grid-template-columns: repeat(3, 1fr);
    }
  `};
`;

const JobsFeed = ({ data: { posts } }) => {
  const items = posts?.nodes?.map((item) => ({
    role: item?.role?.name,
    heading: item?.name,
    location: item?.location?.name,
    jobType: item?.jobType?.name,
    url: item?.url,
    salary: item?.salary,
    salaryExtraInfo: item?.salaryExtraInfo,
    label: 'View details',
    id: item?.id,
  }));

  return (
    <StyledDiv>
      {items?.map((item) => (
        <Card
          key={item.id}
          heading={item.heading}
          headingSize="medium"
          role={item.role}
          location={item.location}
          jobType={item.jobType}
          salary={item.salary}
          salaryExtraInfo={item.salaryExtraInfo}
          linkLabel="See full details"
          url={item.url}
          arrowRight
        />
      ))}
    </StyledDiv>
  );
};

export default JobsFeed;

export const query = graphql`
  query JobsFeedQuery {
    posts: allUmbracoJobAdvertType(sort: { closingDate: ASC }) {
      nodes {
        ...JobAdvertCard
      }
    }
  }
`;
